import { Component, OnInit, Input } from '@angular/core';
import { Item } from '../../../../core/models/item.model';
import { GiftBagService } from 'src/app/shared/components/gift-bag/gift-bag.service';

@Component({
  selector: 'app-gift-bag-card',
  templateUrl: './gift-bag-card.component.html',
  styleUrls: ['./gift-bag-card.component.scss']
})
export class GiftBagCardComponent implements OnInit {

  @Input() item: Item;

  constructor(
    private giftBagService: GiftBagService
  ) { }

  ngOnInit() {
  }

  onRemove() {
    this.giftBagService.removeItemBag(this.item.description);
  }

}
